export default __webpack_public_path__ + "static/media/notify.4f643149.svg";